import { useState } from 'react';
import clsx from 'clsx';
import { $cardUsersStore } from '@lib/store';
import type { UsersResponse } from '@shared/api/rest/users';
import { RemoveUserItem } from '../removeUserItem';
import { Button, Modal } from '@shared/widgets';

interface IRemoveUsersModalProps {
  show: boolean;
  onClose: () => void;
  title: string;
  cardId: string;
  usersList: UsersResponse[];
}

export const RemoveUsersModal = (props: IRemoveUsersModalProps) => {
  const [selectedUsers, setSelectedUsers] = useState<string[]>([]);

  const closeHandler = () => {
    setSelectedUsers([]);
    props.onClose();
  };
  const confirmRemoveHandler = async () => {
    if (!selectedUsers.length) {
      closeHandler();
      return;
    }
    await Promise.allSettled(selectedUsers.map((userId) => $cardUsersStore.events.deleteUserInCard({ userIds: userId, cardIds: [props.cardId] })));
    setSelectedUsers([]);
    props.onClose();
  };

  return (
    <Modal title={props.title} isOpen={props.show} onClose={closeHandler}>
      {props.usersList.map((user) => (
        <RemoveUserItem
          key={user.id}
          className={clsx(selectedUsers.includes(user.id) && 'opacity-50 pointer-events-none')}
          firstName={`${user.firstName || ''} ${user.lastName || ''}`}
          removeItems={() => setSelectedUsers((prev) => [...prev, user.id])}
        />
      ))}
      <div className='mt-6'>
        <Button color='primary' fullWidth onClick={confirmRemoveHandler}>
          Confirm
        </Button>
      </div>
    </Modal>
  );
};
